import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("mline_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("mline_cart", JSON.stringify(items));
  }, [items]);

  const add = (car) => {
    setItems((prev) => {
      const found = prev.find((i) => i.car.id === car.id);
      if (found) {
        return prev.map((i) => (i.car.id === car.id ? { ...i, qty: i.qty + 1 } : i));
      }
      return [...prev, { car, qty: 1 }];
    });
    setOpen(true);
  };

  const remove = (id) => setItems((prev) => prev.filter((i) => i.car.id !== id));

  const setQty = (id, qty) =>
    setItems((prev) =>
      qty <= 0 ? prev.filter((i) => i.car.id !== id) : prev.map((i) => (i.car.id === id ? { ...i, qty } : i))
    );

  const clear = () => setItems([]);

  const value = useMemo(
    () => ({
      items,
      add,
      remove,
      setQty,
      clear,
      open,
      setOpen,
      count: items.reduce((s, i) => s + i.qty, 0),
      total: items.reduce((s, i) => s + i.qty * i.car.price_eur, 0),
    }),
    [items, open]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);

export const formatEUR = (v) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(v);
